import {getApp, getApps, initializeApp} from "firebase/app";

// Sign-in pages are served from the site's own address (netlify.toml passes /__/ on to Firebase): phone browsers
// keep firebaseapp.com's storage apart from the site's, so a sign-in finished there can't reach the page.
// Each address used here needs https://<address>/__/auth/handler in the Google sign-in client's redirect addresses.
function authDomain() {
    // NEXT_PUBLIC_SAME_ORIGIN_AUTH_HOSTS adds hosts set up for it (comma-separated), such as the Railway previews
    const extraHosts = (process.env.NEXT_PUBLIC_SAME_ORIGIN_AUTH_HOSTS || "").split(",").map((h) => h.trim()).filter(Boolean);
    if (typeof window !== "undefined" && (/(^|\.)mytales\.io$|--mytales\.netlify\.app$/.test(window.location.hostname)
        || extraHosts.includes(window.location.hostname))) {
        return window.location.host;
    }
    return process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN;
}

let app;
if (getApps().length === 0) {
    // Initialize Firebase app
    app = initializeApp({
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
        authDomain: authDomain(),
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    });
} else {
    // Use existing app if already initialized
    app = getApp();
}

export const firebaseApp = app;
